<template>
  <div class="">
    <button 
      type="button" 
      class="text-indigo-600 hover:text-indigo-800"
      @click="openModal()"
    >
      <i class="fas fa-plus-circle text-xl"></i>
    </button>

    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Add New Contact
        </h1>

        <form @submit.prevent="submit" class="mt-6">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-4 pr-6 w-full lg:w-1/2" label="First name" />
            <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-4 pr-6 w-full lg:w-1/2" label="Last name" />
            <text-input v-model="form.email" :error="form.errors.email" class="pb-4 pr-6 w-full lg:w-1/2" label="Email" />
            <phone-input v-model.phoneFormat="form.phone" :error="form.errors.phone" class="relative pr-6 pb-2 w-full lg:w-1/2" label="Phone" />
            <select-input v-model="form.type" :error="form.errors.type" class="pb-4 pr-6 w-full lg:w-1/2" label="Type">
              <option :value="null" />
              <option value="Realtor">Realtor</option>
              <option value="Financial Planner">Financial Planner</option>
              <option value="Family">Family</option>
              <option value="Loan Officer">Loan Officer</option>
              <option value="Account Executive">Account Executive</option>
              <option value="Title Agent">Title Agent</option>
              <option value="Insurance Agent">Insurance Agent</option>
              <option value="Attorney">Attorney</option>
            </select-input>
            <text-input v-model="form.license" :error="form.errors.license" class="pb-8 pr-6 w-full lg:w-1/2"
                label="License Number" @blur="update" />
          </div>

          <div class="px-6 py-4 border-gray-200 flex justify-center items-center">
            <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Contact</loading-button>
          </div>
        </form>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import PhoneInput from '@/Shared/PhoneInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'

export default {
  components: {
    TextInput,
    PhoneInput,
    LoadingButton,
    SelectInput,
    ModalHeadlessUI,
  },
  emits: ['success'],
  props: {
    organizationId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      form: router.form({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        license: '',
        type: '',
        organization_id: this.organizationId,
        is_quick_modal: true
      }),
    }
  },
  methods: {
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
      this.form.reset()
    },
    submit() {
      this.form.post('/contacts', {
        preserveScroll: true,
        preserveState: true,
        onSuccess: () => {
          this.$emit('success')
          this.closeModal()
          this.form.reset()
        },
      })
    },
  },
}
</script>